import { SecurityAccessFeaturesEnum } from 'bff';
import { FeatureToggleRoute } from 'modules/app/components/atoms/feature-flags/useFeature';
import { RouteGuard } from 'components/atoms/route-guard/RouteGuard';
import { RouteBoundary } from 'components/organisms/route-boundary/RouteBoundary';
import { IntermediaryDashboard } from 'modules/dashboard/components/pages/intermediary/IntermediaryDashboard';
import { NotFound } from 'modules/app/components/pages/not-found/NotFound';
import { RouteObject } from 'react-router-dom';

export const dashboardRoutes: RouteObject[] = [
  {
    path: '',
    index: true,
    element: (
      <FeatureToggleRoute
        component={
          <RouteGuard
            component={
              <RouteBoundary>
                <IntermediaryDashboard />
              </RouteBoundary>
            }
            features={[SecurityAccessFeaturesEnum.Dashboard]}
          />
        }
        fallback={<NotFound />}
        feature='showDashboard'
      />
    )
  }
];
